import { Button, Form, Input, Modal, message } from 'antd';
import React, { FC, useCallback, useState } from 'react';

const FORM_ID = 'add-hierarchy-entity-form';

const AddHierarchyEntityPopup: FC<any> = ({
	onCancel,
	onSuccess,
	onSave,
	parentData,
	entityName,
	requiredParams,
}): React.ReactElement => {
	const [saving, setSaving] = useState(false);

	const handleSubmit = useCallback(
		(values) => {
			setSaving(true);
			onSave({
				name: values.name,
				...requiredParams,
				...(parentData && { parentId: parentData.id }),
			})
				.then(() => onSuccess())
				.catch((err) => message.error(err))
				.finally(() => setSaving(false));
		},
		[onSave, onSuccess, parentData, requiredParams]
	);

	return (
		<Modal
			visible={true}
			title={parentData ? `Add ${entityName} under '${parentData.name}'` : `Add new ${entityName}`}
			onCancel={onCancel}
			footer={[
				<Button onClick={onCancel} size="large">
					Cancel
				</Button>,
				<Button
					type="primary"
					size="large"
					style={{ marginLeft: '16px' }}
					key="submit"
					htmlType="submit"
					form={FORM_ID}
					loading={saving}
				>
					Save
				</Button>,
			]}
			closable={true}
		>
			<Form id={FORM_ID} layout="vertical" requiredMark={false} onFinish={handleSubmit}>
				<Form.Item
					name="name"
					label="Name"
					rules={[{ required: true, message: `Please enter a name for the ${entityName}!` }]}
				>
					<Input type="text" placeholder={`Enter Name of this ${entityName}`} />
				</Form.Item>
			</Form>
		</Modal>
	);
};

export default AddHierarchyEntityPopup;
